import { z } from "zod";

export const versionSchema = z
  .string()
  .min(1, "Version cannot be empty")
  .regex(/^\d+(\.\d+)*$/, "Invalid version format. Expected format: 1.0.0");
